import { FactureFournisseurStatsDTO } from '@/models/FactureFournisseurStatsDTO';
import { ReglementDTO } from '@/models/ReglementDTO';

export interface DashboardFournisseurState {
    statsFactures: FactureFournisseurStatsDTO,
    reglementsDTO: ReglementDTO[],
}

export const initialState: DashboardFournisseurState = {
    statsFactures: {nbRejetees: 0, nbLitige: 0, nbValidees:0, nbAValider:0, nbPayees:0},
    reglementsDTO: []
};

export const state: DashboardFournisseurState = {
    ...initialState
};
